import { render, staticRenderFns } from "./WriteOffClientsModal.vue?vue&type=template&id=58846eb4"
import script from "./WriteOffClientsModal.vue?vue&type=script&lang=js"
export * from "./WriteOffClientsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports